import { useEffect } from 'react';
import { Navigate, Routes } from 'react-router-dom';
import { useAuth } from './core/Auth';
export function Logout() {
  const { logout } = useAuth();
  useEffect(() => {
    logout();
    document.location.reload();
  }, [logout]);
  const userResellerId = localStorage.getItem('userResellerId')
  return (<Routes>
   { userResellerId!=null?<> <Navigate to='/auth/login' />
    </>:<> <Navigate to='/auth/resellerLogin' />
    </>}
  </Routes>);
}
